import React from 'react';
import ItemLayout from './Item';

export default function Item({ item }) {
  const renderSubPanelConectores = (conectores) => {
    return conectores.map((conector) => <ItemLayout item={conector} key={item.cdCliente} />);
  };

  return <>{renderSubPanelConectores(item.conectores)}</>;
}
